module.exports = __webpack_public_path__ + "static/media/icons.1dc5b869.svg";